import Vue from 'vue'
import Router from 'vue-router'
import Home from 'views/Home'
import OrthodonticSmile from 'views/OrthodonticSmile'
import TeethWhitening from 'views/TeethWhitening'
import OrthodonticSmileShare from 'views/OrthodonticSmileShare'
import OrthodonticSmileShow from 'views/OrthodonticSmileShow'
import OrthodonticSmileEdit from 'views/OrthodonticSmileEdit'
import CaseHistory from 'views/CaseHistory'
import AccountManagement from 'views/AccountManagement'
import PromotionCodeList from 'views/PromotionCodeList'
import Login from 'views/Login'
import Verify from'views/Verify'
import Register from 'views/Register'
import Welcome from 'views/Welcome'
import Setting from 'views/Setting'
import Feedback from 'views/Feedback'
import FeedbackList from 'views/FeedbackList'


Vue.use(Router)

const routes = [
  {
    path: '/',
    redirect: '/orthodonticSmile'
  },
  {
    path: '/home',
    component: Home,
    meta: { title: 'Home' },
  },
  {
    path: '/orthodonticSmile',
    component: OrthodonticSmile,
    meta: { title: 'Smile Camera', childTitle:'Orthodontic Smile'},
  },
  {
    path: '/teethWhitening',
    component: TeethWhitening,
    meta: { title: 'Smile Camera', childTitle:'Teeth Whitening'},
  },
  {
    path: '/orthodonticSmileShow',
    component: OrthodonticSmileShow,
    meta: { title: 'Case History'},
  },
  {
    path: '/orthodonticSmileEdit',
    component: OrthodonticSmileEdit,
    meta: { title: 'Case History'},
  },
  {
    path: '/caseHistory',
    component: CaseHistory,
    meta: { title: 'Case History'},
  },
  {
    path: '/feedback',
    component: Feedback,
    meta: { title: 'Feedback'},
  },
  {
    path: '/accountManagement',
    component: AccountManagement,
    meta: { title: 'Setting', childTitle:'Account Management'},
  },
  {
    path: '/promotionCode',
    component: PromotionCodeList,
    meta: { title: 'Setting', childTitle:'Promotion Code'},
  },
  {
    path: '/feedbackList',
    component: FeedbackList,
    meta: { title: 'Setting', childTitle:'Feedback List'},
  },
  {
    path: '/setting',
    component: Setting,
    meta: { title: 'Setting', childTitle:'Setting'},
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/verify',
    component: Verify
  },
  {
    path: '/register',
    component: Register
  },
  {
    path: '/OrthodonticSmileShare/:uuid',
    component: OrthodonticSmileShare
  },
  {
    path: '/welcome',
    component: Welcome
  },
  {
    path: '/404',
    component: () => import('views/exception/404')
  },
  {
    path: '*',
    redirect: '/404',
  }
]
const router = new Router({
  routes,
  mode: 'history',
  scrollBehavior(to,from,savePosition){
    if(savePosition){
      return savePosition
    } else {
      return {x:0,y:0}
    }
  }
})
export default router
